// @flow
import React, { PureComponent } from 'react';

export type StateProps = {
    news: Array<any>,
    newsCat: Object
};

type Props = StateProps;

class TeamMenuNews extends PureComponent<Props>{
  renderNews() {
    const { news } = this.props;
    return news.map<any>( ( article, index ) => {
      if (index > 3) {
        return null;
      }
      return (
        <a key={index} className="news" href={article.link}>
          <span className="news__title ft-h5">
            {article.title}
            <p className="ft-h6">{article.date}</p>
          </span>
        </a>
      );
    });
  }

  render() {
    const { newsCat } = this.props;
    return (
        this.props.news &&
        <div className="col col-md-6 col-lg-4">
          <div className="box box--white card card--news box--white">
            <div className="card__body">
              <h3 className="ft-h3 mb-2">Dernières actualités</h3>
              { this.renderNews() }
            </div>
            { newsCat && newsCat.slug && 
            <div className="card__footer">
              <a href={`/actualites/${newsCat.slug}`} 
                className="link-chevron link-chevron--block" 
                data-label="">
                  <span>{ 'Consulter plus d\'actualités'}</span>
                  <i className="icon icon-chevron-right"></i>
              </a>
            </div> }
          </div>
        </div>
    );
  }
};

export default TeamMenuNews;
